(function () {
  var root = document.body;
  if (!root || (!root.classList.contains('gds-collection-page') && !root.classList.contains('gds-all-collections-page'))) return;

  var revealEls = root.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      revealEls.forEach(function (el) { el.classList.add('in-view'); });
    }, 1200);
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  /* Collection filters drawer (mobile) + AJAX updates */
  var drawer = document.querySelector('[data-gds-filter-drawer]');
  var openBtns = document.querySelectorAll('.js-gds-filters-open');
  var closeBtns = document.querySelectorAll('.js-gds-filters-close');

  function setDrawerOpen(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.classList.toggle('gds-filters-open', open);
    openBtns.forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var panel = drawer.querySelector('.gds-filters-panel');
    var scrim = drawer.querySelector('.gds-filter-drawer__scrim');
    if (panel) {
      panel.setAttribute('aria-modal', open ? 'true' : 'false');
    }
    if (scrim) scrim.hidden = !open;
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { setDrawerOpen(true); });
  });
  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () { setDrawerOpen(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawerOpen(false);
  });

  var form = document.getElementById('facets');
  var results = document.getElementById('filter-results');
  if (!form || !results) return;

  var debounceTimer = null;
  var abortCtrl = null;

  function buildParams(fromForm) {
    var fd = new FormData(fromForm);
    var params = new URLSearchParams(fd);
    var empty = [];
    params.forEach(function (value, key) {
      if (!value) empty.push(key);
    });
    empty.forEach(function (key) { params.delete(key); });
    return params;
  }

  async function applyFilters(params, updateUrl, closeDrawer) {
    var sectionId = form.getAttribute('data-filter-section-id');
    var qs = params.toString();
    var fetchUrl = window.location.pathname + '?' + qs;
    if (sectionId) fetchUrl += (qs ? '&' : '') + 'section_id=' + encodeURIComponent(sectionId);

    results.classList.add('is-loading');
    try {
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();
      var res = await fetch(fetchUrl, { signal: abortCtrl.signal });
      if (!res.ok) throw new Error(String(res.status));
      var html = await res.text();
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var newFacets = tmp.querySelector('#facets');
      var newResults = tmp.querySelector('#filter-results');
      var newCount = tmp.querySelector('[data-gds-results-count]');
      var newToggle = tmp.querySelector('.js-gds-filters-open');
      if (newFacets) form.innerHTML = newFacets.innerHTML;
      if (newResults) results.innerHTML = newResults.innerHTML;
      if (newCount) {
        var countEl = document.querySelector('[data-gds-results-count]');
        if (countEl) countEl.innerHTML = newCount.innerHTML;
      }
      if (newToggle) {
        openBtns.forEach(function (btn) {
          btn.innerHTML = newToggle.innerHTML;
          btn.setAttribute('aria-expanded', drawer && drawer.classList.contains('is-open') ? 'true' : 'false');
        });
      }
      if (updateUrl !== false) {
        var next = window.location.pathname + (qs ? '?' + qs : '') + '#products';
        window.history.pushState({ searchParams: qs }, '', next);
      }
      // Rebind close buttons inside replaced form
      form.querySelectorAll('.js-gds-filters-close').forEach(function (btn) {
        btn.addEventListener('click', function () { setDrawerOpen(false); });
      });
      bindForm();
      // Keep mobile drawer open while refining filters; close only on Apply / Clear
      if (closeDrawer) setDrawerOpen(false);
    } catch (err) {
      if (err && err.name === 'AbortError') return;
      // Fallback: full navigation
      window.location.href = window.location.pathname + (qs ? '?' + qs : '') + '#products';
    } finally {
      results.classList.remove('is-loading');
    }
  }

  function onFilterChange(e) {
    if (e.target && e.target.closest && e.target.closest('.gds-filter__price')) {
      if (e.type === 'input') return;
    }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      // On mobile drawer, keep panel open so shoppers can multi-select
      var keepOpen = drawer && drawer.classList.contains('is-open');
      applyFilters(buildParams(form), true, !keepOpen);
    }, 280);
  }

  function bindForm() {
    form.removeEventListener('change', onFilterChange);
    form.removeEventListener('input', onFilterChange);
    form.addEventListener('change', onFilterChange);
    form.addEventListener('input', onFilterChange);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      applyFilters(buildParams(form), true, true);
    });
  }

  bindForm();

  form.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.gds-facets__chip, a.gds-facets__clear-all');
    if (!a) return;
    e.preventDefault();
    var url = new URL(a.href, window.location.origin);
    applyFilters(url.searchParams, true, true);
  });

  window.addEventListener('popstate', function (e) {
    var qs = (e.state && e.state.searchParams) || window.location.search.replace(/^\?/, '');
    applyFilters(new URLSearchParams(qs), false, false);
  });
})();

/* Subcategory slider progress indicator */
(function () {
  function bindCatSlider(shell) {
    var scroller = shell.querySelector('[data-gds-cat-slider], .cat-carousel--slider');
    var track = shell.querySelector('.cat-carousel-progress');
    var bar = shell.querySelector('.cat-carousel-progress__bar');
    if (!scroller || !track || !bar) return;

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      if (max <= 4) {
        track.hidden = true;
        return;
      }
      track.hidden = false;
      var thumb = Math.max((scroller.clientWidth / scroller.scrollWidth) * 100, 18);
      var left = (scroller.scrollLeft / max) * (100 - thumb);
      bar.style.width = thumb + '%';
      bar.style.left = left + '%';
    }

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(scroller);
    }
    requestAnimationFrame(update);
    setTimeout(update, 120);
  }

  function init() {
    document.querySelectorAll('.gds-coll-subcats .cat-carousel-shell').forEach(bindCatSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
